{
  "page_count": "av {n, plural, one{# sida} other{# sidor}}"
}
